import React from 'react';
import { NavLink, Outlet, useParams, useNavigate } from 'react-router-dom';
import {
  ArrowLeftIcon,
  DocumentTextIcon,
  ReceiptPercentIcon,
  EnvelopeIcon,
  UserCircleIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline';

const tabs = [
  { name: 'Propuestas', to: 'proposal', icon: DocumentTextIcon },
  { name: 'Facturas', to: 'invoices', icon: ReceiptPercentIcon },
  { name: 'Mensajes', to: 'email', icon: EnvelopeIcon },
  { name: 'Perfil', to: 'profile', icon: UserCircleIcon },
  { name: 'Seguimiento', to: 'tracking', icon: WrenchScrewdriverIcon },
  { name: 'Servicio', to: 'service', icon: WrenchScrewdriverIcon },
];

const ClientLayout = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();

  return (
    <section className="mx-auto max-w-7xl space-y-6 px-4 pb-12 pt-6">
      <div className="rounded-3xl border border-[var(--admin-border)] bg-white px-6 py-5 shadow-sm">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-[var(--admin-muted)]">
              Cliente activo
            </p>
            <h2 className="text-2xl font-bold text-[var(--admin-text)]">{clientId}</h2>
            <p className="text-sm text-gray-500">
              Gestiona propuestas, facturas, servicio y mensajería sin salir de esta vista.
            </p>
          </div>
          <button
            onClick={() => navigate('/admin/clients')}
            className="inline-flex items-center gap-2 rounded-full border border-[var(--admin-border)] px-5 py-3 text-sm font-semibold text-[var(--admin-text)] transition hover:bg-gray-50"
          >
            <ArrowLeftIcon className="h-5 w-5" />
            Volver a clientes
          </button>
        </div>

        <div className="mt-5 overflow-x-auto">
          <nav className="flex min-w-max flex-nowrap gap-2 rounded-2xl bg-[var(--admin-surface)] p-2">
            {tabs.map(({ name, to, icon: Icon }) => (
              <NavLink
                key={to}
                to={`/admin/clients/${clientId}/${to}`}
                className={({ isActive }) =>
                  [
                    'flex flex-none items-center justify-center gap-2 whitespace-nowrap rounded-2xl px-4 py-2 text-[10px] font-semibold uppercase tracking-wide transition sm:text-xs',
                    isActive
                      ? 'bg-[var(--admin-primary)] text-white shadow-lg shadow-emerald-100'
                      : 'text-[var(--admin-muted)] hover:bg-white hover:text-[var(--admin-primary)]',
                  ].join(' ')
                }
              >
                <Icon className="h-4 w-4" />
                {name}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>

      <div className="rounded-3xl border border-[var(--admin-border)] bg-white p-6 shadow-sm">
        <Outlet />
      </div>
    </section>
  );
};

export default ClientLayout;
